import React from 'react'
import MexPage from './MexPage'

function MexPageContainer() {
    return (
        <div className='MexPageContainer'>
            <MexPage/>
        </div>
    )
}

export default MexPageContainer